/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Stable machine-readable Roadmap Audit API error.
 */
export type RoadmapAuditErrorDetail = {
    code: RoadmapAuditErrorDetail.code;
    message: string;
};

export namespace RoadmapAuditErrorDetail {

    export enum code {
        ROADMAP_SNAPSHOT_UNAVAILABLE = 'roadmap_snapshot_unavailable',
        UNKNOWN_AUDIT_RULE = 'unknown_audit_rule',
        INVALID_AUDIT_FILTER = 'invalid_audit_filter',
        ROADMAP_AUDIT_IDENTITY_UNAVAILABLE = 'roadmap_audit_identity_unavailable',
        AUDIT_CURSOR_GENERATION_MISMATCH = 'audit_cursor_generation_mismatch',
        ROADMAP_AUDIT_INDEX_UNAVAILABLE = 'roadmap_audit_index_unavailable',
    }


}

